import { useNavigation, useParams } from 'react-router-dom'

// @ts-expect-error - Component type is not properly inferred
const withMatch = (Comp) => {
  const WithMatchComponent = (props: Record<string, unknown>) => (
    <Comp {...props} match={{ params: useParams(), ...useNavigation() }} />
  )
  WithMatchComponent.displayName = `withMatch(${Comp.displayName || Comp.name || 'Component'})`
  return WithMatchComponent
}

export default withMatch
